import { render, staticRenderFns } from "./FeedbackActivity.vue?vue&type=template&id=3dcab77c&scoped=true"
import script from "./FeedbackActivity.vue?vue&type=script&lang=ts"
export * from "./FeedbackActivity.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackActivity.vue?vue&type=style&index=0&id=3dcab77c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcab77c",
  null
  
)

export default component.exports